var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCutieFox11S201Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 201,
    preserveAspectRatio: "xMidYMid",
    style: {
      margin: "auto",
      background: "0 0",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.10526315789473684s",
    calcMode: "spline",
    dur: "1.0526315789473684s",
    keySplines: "0.5 0 0.5 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "360 50 50;0 50 50"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    fill: "none",
    stroke: "#ffc107",
    strokeDasharray: "0 300",
    strokeWidth: 14.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    begin: "-0.04842105263157894s",
    calcMode: "linear",
    dur: "1.0526315789473684s",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "15 300;55.1413599195142 300;15 300"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    fill: "none",
    stroke: "#fff1cf",
    strokeDasharray: "0 300",
    strokeWidth: 7.2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    begin: "-0.04842105263157894s",
    calcMode: "linear",
    dur: "1.0526315789473684s",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "15 300;55.1413599195142 300;15 300"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 32.771,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    begin: "-0.04842105263157894s",
    calcMode: "linear",
    dur: "1.0526315789473684s",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "15 300;45.299378454348094 300;15 300"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.171,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    begin: "-0.04842105263157894s",
    calcMode: "linear",
    dur: "1.0526315789473684s",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    keyTimes: "0;0.5;1",
    repeatCount: "indefinite",
    values: "15 300;66.03388996804073 300;15 300"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    calcMode: "spline",
    dur: "1.0526315789473684s",
    keySplines: "0.5 0 0.5 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "360 50 50;0 50 50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    stroke: "#000",
    d: "M97.2 50c0 6.1-1.2 12.2-3.5 17.8l-13.3-5.4c1.6-3.9 2.4-8.2 2.4-12.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff1cf",
    d: "M93.6 49.9c0 1.2 0 2.4-.1 3.6l-.5 3.6c-.4 2-2.3 3.3-4.2 2.8l-.2-.1c-1.8-.5-3.1-2.3-2.7-3.9l.4-3c.1-1 .1-2 .1-3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    stroke: "#000",
    d: "M85.4 62.5c-.2.7-.5 1.4-.8 2.1-.3.7-.6 1.4-.9 2-.6 1.1-2 1.4-3.2.8-1.1-.7-1.7-2-1.2-2.9.3-.6.5-1.2.8-1.8.2-.6.6-1.2.7-1.8M94.5 65.7c-.3.9-.7 1.7-1 2.6-.4.8-.7 1.7-1.1 2.5-.7 1.4-2.3 1.9-3.4 1.3-1.1-.7-1.5-2.2-.9-3.4.4-.8.7-1.5 1-2.3.3-.8.7-1.5.9-2.3M85.6 67c0 .8.1 1.6.3 2.4.6-.5 1.1-1 1.4-1.7.2-.7.2-1.5-.1-2.2-.7-1.5-1.6.8-1.6 1.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    begin: "-0.10526315789473684s",
    calcMode: "spline",
    dur: "1.0526315789473684s",
    keySplines: "0.5 0 0.5 1",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    type: "rotate",
    values: "360 50 50;0 50 50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff1cf",
    stroke: "#000",
    d: "m91 33.6-10 4c-.4-1.2-1.1-2.4-1.7-3.5-.2-.5.3-1.1.9-1 3.4-.2 7.2-.2 10.8.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff1cf",
    stroke: "#000",
    d: "m83.2 36.7 10-4c-.6-1.7-1.5-3.3-2.3-4.9-.3-.7-1.2-.6-1.4.1-1.9 3.2-3.8 6.1-6.3 8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    stroke: "#000",
    d: "M82.8 50.2c0-3.4-.5-6.8-1.5-10-.2-.8-.4-1.5-.3-2.3.1-.8.4-1.6.7-2.4.7-1.5 1.9-3.1 3.7-4 1.8-.9 3.7-1 5.6-.3.9.4 1.7 1 2.4 1.8s1.3 1.7 1.7 2.8c1.5 4.6 2.2 9.5 2.2 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff1cf",
    d: "M86.4 50.3v-.9l-.1-.9-.1-1.9c0-.9.2-1.7.7-2.3.5-.7 1.3-1.2 2.3-1.4h.3c.9-.2 1.9 0 2.6.6.7.5 1.3 1.4 1.4 2.4l.2 2.2.1 1.1v1.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6 36.6c.1.3-.2.7-.6.8-.5.2-.9 0-1.1-.3-.1-.3.2-.7.6-.8.5-.2 1-.1 1.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M86 38.7c.2.6.8.9 1.4.7.6-.2.9-.9.6-2.1.3 1.2 1 1.7 1.6 1.5.6-.2.9-.8.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    stroke: "#000",
    d: "m86.8 42.2.4 2.2c.1.4.1.7.2 1.1l.1 1.1c.1 1.2-.9 2.3-2.2 2.3-1.3 0-2.5-.8-2.5-1.9l-.1-1c0-.3-.1-.6-.2-1l-.3-1.9M96.2 40.2l.5 2.7c.1.5.2.9.2 1.4l.1 1.4c.1 1.5-.9 2.8-2.2 2.8-1.3 0-2.5-1.1-2.6-2.4l-.1-1.2c0-.4-.1-.8-.2-1.2l-.4-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    d: "M90.9 36.4c1.1-1.1 2.7-1.6 4.3-1.9M91.6 37.5c1.3-.5 2.8-.8 4.2-.7M91.7 38.8c.2-.1.4-.1.7-.1 1.2-.1 2.5 0 3.8.3M85 38.4c-1.6-.1-3.1.6-4.6 1.2M85 39.5c-1.4.3-2.8.9-4 1.6M85.5 40.4c-.2 0-.4.1-.7.2-1.1.5-2.2 1.1-3.2 1.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff7bac",
    d: "M92.8 34.2c.1.3-.3.8-.9 1-.6.2-1.2.1-1.4-.2-.1-.3.3-.8.9-1 .7-.2 1.3-.1 1.4.2zM82.2 38.2c.1.3.7.3 1.3.1.6-.2 1-.6.9-.9-.1-.3-.7-.3-1.3-.1-.6.2-1.1.6-.9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90 35.7-.7.3-.3-.7c-.3-.9.1-1.9.9-2.3l.7-.3.3.7c.4 1 0 2-.9 2.3zM85.3 37.4l.7-.2-.2-.6c-.3-.8-1.3-1.2-2.1-.8l-.8.2.2.6c.4.8 1.3 1.1 2.2.8z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutieFox11S201Px);
export default __webpack_public_path__ + "static/media/Cutie Fox-1.1s-201px.1ee00bc8d879a8ed6be95e4dcbc1f0c5.svg";
export { ForwardRef as ReactComponent };